import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { ResourceIdentifiers } from '@repo/api-gw-sdk';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
export const ResourceIdentifierItem = t0 => {
  const $ = _c(11);
  const {
    resource
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== resource.providerId) {
    t2 = <OverflowTooltip shouldCloseOnScroll={true} text={resource.providerId} renderContent={_temp} />;
    $[1] = resource.providerId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !resource.id ? "var(--mui-palette-info-main)" : undefined;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      color: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== resource.name || $[6] !== t4) {
    t5 = <Typography variant="body2" className="truncate" sx={t4}>{resource.name}</Typography>;
    $[5] = resource.name;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <Stack className="truncate" sx={t1}>{t2}{t5}</Stack>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(text, ref) {
  return <Typography variant="subtitle1" className="truncate" ref={ref}>{text}</Typography>;
}